import { FEATURE_MANAGEMENT } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { injectable } from "tsyringe";
import { IUserPermissionRepository } from "../domain/repositories/IUserPermissionRepository";
import { DetailUserPermissionRepsosneModel } from "./models/DetailUserPermissionResponseModel";
import { UserPermissionActionRequestModel } from "./models/UserPermissionActionRequestModel";
import { UserPermissionRequestModel } from "./models/UserPermissionRequestModel";
import { UserPermissionRepsonseModel } from "./models/UserPermissionResponseModel";

@injectable()
export class UserPermissionImpl implements IUserPermissionRepository {
  async getList(
    params: UserPermissionRequestModel,
  ): Promise<ListBaseApiResponseModel<UserPermissionRepsonseModel>> {
    return await client?.get(FEATURE_MANAGEMENT.LIST, params);
  }

  async getDetail(
    params: UserPermissionRequestModel,
  ): Promise<BaseApiResponseModel<DetailUserPermissionRepsosneModel>> {
    return await client?.get(FEATURE_MANAGEMENT.DETAIL, params);
  }

  async create(
    body: UserPermissionActionRequestModel,
  ): Promise<BaseApiResponseModel<DetailUserPermissionRepsosneModel>> {
    return await client?.post(FEATURE_MANAGEMENT.CREATE, body);
  }

  async update(
    body: UserPermissionActionRequestModel,
  ): Promise<BaseApiResponseModel<DetailUserPermissionRepsosneModel>> {
    return await client?.put(FEATURE_MANAGEMENT.UPDATE, body);
  }

  async delete(
    params: UserPermissionRequestModel,
  ): Promise<BaseApiResponseModel<DetailUserPermissionRepsosneModel>> {
    return await client?.delete(FEATURE_MANAGEMENT.DELETE, params);
  }
}
